var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"text--base"},[_c('Milestones',{staticClass:"chapter-one__content",attrs:{"content":_vm.milestonesContent}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }